<template>
    <svg :width="size" :height="size-4" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.0283 19.9988L21.9993 4.33008L12.9709 15.3213L11.0283 19.9988Z" fill="#ACACAC"/>
        <path d="M12.9707 15.3228L21.999 4.33008H17.6343L12.9707 15.3228Z" fill="url(#paint0_diamond_71_10971)"/>
        <path d="M15.3044 4.3229L14.4541 1.27539L17.635 4.32871L15.3044 4.3229Z" fill="url(#paint1_diamond_71_10971)"/>
        <path d="M11 4.32295L14.4545 1.27539L15.3048 4.32295H11Z" fill="url(#paint2_diamond_71_10971)"/>
        <path d="M12.9883 15.3194L15.3209 4.32227L17.6508 4.328L12.9883 15.3194Z" fill="url(#paint3_linear_71_10971)"/>
        <path d="M11.0191 0L14.4532 1.27613L10.9985 4.32368L7.54492 1.27441L11.0191 0Z" fill="url(#paint4_diamond_71_10971)"/>
        <path d="M15.3052 4.32422H11L12.9718 15.3218L15.3052 4.32422Z" fill="url(#paint5_diamond_71_10971)"/>
        <path d="M14.455 1.27618L11.0215 0L17.6558 0.00231412L14.455 1.27618Z" fill="url(#paint6_linear_71_10971)"/>
        <path d="M20.002 1.26367L17.6357 4.32911H21.9986L20.002 1.26367Z" fill="url(#paint7_diamond_71_10971)"/>
        <path d="M14.4541 1.27548L17.6357 4.32981L20.0022 1.26634L17.6553 0.00195312L14.4541 1.27548Z" fill="url(#paint8_diamond_71_10971)"/>
        <path d="M11.0283 19.9921L-0.000362396 4.32227L9.02806 15.3135L11.0283 19.9921Z" fill="#A4A4A4"/>
        <path d="M9.02832 15.3228L5.81741e-05 4.33008H4.3647L9.02832 15.3228Z" fill="url(#paint9_diamond_71_10971)"/>
        <path d="M6.69464 4.3229L7.54492 1.27539L4.36398 4.32871L6.69464 4.3229Z" fill="url(#paint10_diamond_71_10971)"/>
        <path d="M11 4.32295L7.54551 1.27539L6.69523 4.32295H11Z" fill="url(#paint11_diamond_71_10971)"/>
        <path d="M9.02734 15.3194L6.69473 4.32227L4.36485 4.328L9.02734 15.3194Z" fill="url(#paint12_linear_71_10971)"/>
        <path d="M6.69484 4.32227H11L9.02823 15.3198L6.69484 4.32227Z" fill="url(#paint13_diamond_71_10971)"/>
        <path d="M7.54636 1.27387L11.0215 0H4.34555L7.54636 1.27387Z" fill="url(#paint14_linear_71_10971)"/>
        <path d="M1.99704 1.26367L4.36328 4.32911H0.000449657L1.99704 1.26367Z" fill="url(#paint15_diamond_71_10971)"/>
        <path d="M7.54492 1.27353L4.3633 4.32786L1.99679 1.26439L4.34372 0L7.54492 1.27353Z" fill="url(#paint16_diamond_71_10971)"/>
        <path d="M12.9714 15.3194L10.9997 4.32227L9.02734 15.3179L11.0285 19.9988L12.9714 15.3194Z" fill="url(#paint17_diamond_71_10971)"/>
        <defs>
        <radialGradient id="paint0_diamond_71_10971" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(17.4848 9.82643) rotate(90) scale(5.49635 4.51413)">
        <stop stop-color="#FDFCFC"/>
        <stop offset="1" stop-color="#ABABAB"/>
        </radialGradient>
        <radialGradient id="paint1_diamond_71_10971" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(16.0446 2.80205) rotate(90) scale(1.52666 1.59047)">
        <stop stop-color="#FFFEFE"/>
        <stop offset="1" stop-color="#B3B3B3"/>
        </radialGradient>
        <radialGradient id="paint2_diamond_71_10971" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(13.1524 2.79917) rotate(90) scale(1.52378 2.15238)">
        <stop stop-color="#FFFEFE"/>
        <stop offset="1" stop-color="#B3B3B3"/>
        </radialGradient>
        <linearGradient id="paint3_linear_71_10971" x1="15.3195" y1="4.32227" x2="15.3195" y2="15.3194" gradientUnits="userSpaceOnUse">
        <stop stop-color="#E2E2E2"/>
        <stop offset="1" stop-color="#9D9D9D"/>
        </linearGradient>
        <radialGradient id="paint4_diamond_71_10971" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(10.9991 2.16184) rotate(90) scale(2.16184 3.45413)">
        <stop stop-color="white"/>
        <stop offset="0.994792" stop-color="#C6C6C6"/>
        </radialGradient>
        <radialGradient id="paint5_diamond_71_10971" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(13.1526 9.82301) rotate(90) scale(5.49879 2.15258)">
        <stop stop-color="#FDFCFC"/>
        <stop offset="1" stop-color="#B8B8B8"/>
        </radialGradient>
        <linearGradient id="paint6_linear_71_10971" x1="14.3386" y1="0" x2="14.3386" y2="1.27618" gradientUnits="userSpaceOnUse">
        <stop stop-color="#A7A7A7"/>
        <stop offset="1" stop-color="#FFFDFD"/>
        </linearGradient>
        <radialGradient id="paint7_diamond_71_10971" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(19.8172 2.79639) rotate(90) scale(1.53272 2.18142)">
        <stop stop-color="#FFFEFE"/>
        <stop offset="1" stop-color="#B3B3B3"/>
        </radialGradient>
        <radialGradient id="paint8_diamond_71_10971" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(17.2282 2.16588) rotate(90) scale(2.16393 2.77407)">
        <stop stop-color="white"/>
        <stop offset="0.994792" stop-color="#C6C6C6"/>
        </radialGradient>
        <radialGradient id="paint9_diamond_71_10971" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(4.51419 9.82643) rotate(90) scale(5.49635 4.51413)">
        <stop stop-color="#FDFCFC"/>
        <stop offset="1" stop-color="#ABABAB"/>
        </radialGradient>
        <radialGradient id="paint10_diamond_71_10971" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(5.95445 2.80205) rotate(90) scale(1.52666 1.59047)">
        <stop stop-color="#FFFEFE"/>
        <stop offset="1" stop-color="#B3B3B3"/>
        </radialGradient>
        <radialGradient id="paint11_diamond_71_10971" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(8.84762 2.79917) rotate(90) scale(1.52378 2.15238)">
        <stop stop-color="#FFFEFE"/>
        <stop offset="1" stop-color="#B3B3B3"/>
        </radialGradient>
        <linearGradient id="paint12_linear_71_10971" x1="6.6961" y1="4.32227" x2="6.6961" y2="15.3194" gradientUnits="userSpaceOnUse">
        <stop stop-color="#E2E2E2"/>
        <stop offset="1" stop-color="#9D9D9D"/>
        </linearGradient>
        <radialGradient id="paint13_diamond_71_10971" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(8.84742 9.82105) rotate(90) scale(5.49879 2.15258)">
        <stop stop-color="#FDFCFC"/>
        <stop offset="1" stop-color="#B8B8B8"/>
        </radialGradient>
        <linearGradient id="paint14_linear_71_10971" x1="7.68352" y1="0" x2="7.68352" y2="1.27387" gradientUnits="userSpaceOnUse">
        <stop stop-color="#A7A7A7"/>
        <stop offset="1" stop-color="#FFFDFD"/>
        </linearGradient>
        <radialGradient id="paint15_diamond_71_10971" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(2.18187 2.79639) rotate(90) scale(1.53272 2.18142)">
        <stop stop-color="#FFFEFE"/>
        <stop offset="1" stop-color="#B3B3B3"/>
        </radialGradient>
        <radialGradient id="paint16_diamond_71_10971" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(4.77085 2.16393) rotate(90) scale(2.16393 2.77407)">
        <stop stop-color="white"/>
        <stop offset="0.994792" stop-color="#C6C6C6"/>
        </radialGradient>
        <radialGradient id="paint17_diamond_71_10971" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(10.9994 12.1605) rotate(90) scale(7.83825 1.97205)">
        <stop stop-color="white"/>
        <stop offset="0.994792" stop-color="#C6C6C6"/>
        </radialGradient>
        </defs>
    </svg>
</template>
<script>
export default {
    name: "VipFree",
    props: {
        size: {
            type: Number,
            default: 22,
        },
    },
};
</script>
